import React from "react";
import { Link } from "react-router-dom";
import { Route, useHistory } from "react-router";
import { FormattedMessage } from "react-intl";

import { getAppFromHistory, getAppPrefix } from "../../../common/app";
import routing from "../../routing";

import { StyledFotter, FooterItem, FooterSpring, FixedBottomBlock } from "./styles";
import messages from "./messages";

const Footer = () => {
    const history = useHistory();
    const app = getAppFromHistory(history);
    const prefix = getAppPrefix(app);
    if (history.location.pathname.includes(routing.practice)) return null;
    return (
        <StyledFotter>
            <FooterSpring>
                <FooterItem>
                    <Link to={prefix + "/" + routing.contact}>
                        <FormattedMessage {...messages.contact} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <Link to={prefix + "/" + routing.terms}>
                        <FormattedMessage {...messages.terms} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <Link to={prefix + "/" + routing.privacy}>
                        <FormattedMessage {...messages.privacy} />
                    </Link>
                </FooterItem>
                <FooterItem>
                    <FormattedMessage {...messages.copyright} values={{ year: 2026 }} />
                </FooterItem>
            </FooterSpring>
            <Route path={`/${routing.pack}/:id`} component={() => <FixedBottomBlock />} />
            <Route path={`/${routing.plan}/:id`} component={() => <FixedBottomBlock />} />
            <Route path={`/${routing.publicPlan}/:id`} component={() => <FixedBottomBlock />} />
        </StyledFotter>
    );
};

export default Footer;
